import React, { Component } from 'react'; 
import { connect } from 'react-redux';
import { getChiTietCLSAction,saveDataCLSAction } from '../actions/authenticationActions';
import * as Lang from '../lang';
import Pdfview from './Pdfview';
import Imageview from './Imageview';
import { ToastContainer, toast } from 'react-toastify';    
import 'react-toastify/dist/ReactToastify.css';   
import HeaderPage from './headerPage';
import {
  isMobile
} from "react-device-detect";
import * as config from '../config';

class Cls extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chandoan1: "",
      chandoan2:"",
      chandoan3:"",
      isedit:false,
    };
    this.issave=0;
    this.isdisabled=0;
    this.luu_ketqua1="";
    this.luu_ketqua2="";
    this.luu_ketqua3="";
    this.get_id=0;
    this.pdf_view="";
  }
  handleHome=()=>{ 
    window.open('/dashboard', '_self', ''); 
  }
  chandoan1Change = evt => { 
    this.luu_ketqua1=evt.target.value;
  }
  chandoan2Change = evt => {
    this.luu_ketqua2=evt.target.value;
  }
  chandoan3Change = evt => {
    this.luu_ketqua3=evt.target.value;
  } 
  handleOpenLink=link=>{
    window.open(link, '_self', ''); 
  }

  handleSave = evt => {
    let chandoan1,chandoan2,chandoan3,hoantat,id,token;
    chandoan1=this.luu_ketqua1;
    chandoan2=this.luu_ketqua2;
    chandoan3=this.luu_ketqua3;
    id=this.props.response.chitietcls.response.data.chandoan[0].kham_id;
    hoantat=this.state.isedit===true?1:0;
    token=localStorage.getItem('token');
    this.issave=1; 
    const data = { chandoan1,chandoan2,chandoan3,hoantat,id,token};
    this.props.dispatch(saveDataCLSAction(data)); 
  }
  handleEdit = evt => {
    this.setState({
      isedit:true
    })
  }
  handleSaveAndDone = evt => {
    let chandoan1,chandoan2,chandoan3,hoantat,id,token;
    chandoan1=this.luu_ketqua1;
    chandoan2=this.luu_ketqua2;
    chandoan3=this.luu_ketqua3;
    id=this.props.response.chitietcls.response.data.chandoan[0].kham_id;
    token=localStorage.getItem('token');
    hoantat=1;
    this.issave=1;
    const data = { chandoan1,chandoan2,chandoan3,hoantat,id,token};
    this.props.dispatch(saveDataCLSAction(data));
    this.isdisabled=1;
  } 
  componentDidMount() {
    document.title = Lang.LANG_TITLE;
    const { match: { params } } = this.props;
    this.get_id=params.id;
    let id=this.get_id;
    let token=localStorage.getItem('token');
    const data = {id,token};
    this.issave=0;
    this.props.dispatch(getChiTietCLSAction(data));
    this.setState({
      isedit:false
    })
  }
  render() { 
    
    const col_parent = {  
    };
    const colleftstyle = { 
      fontFamily: "Arial",  
      borderTop:"1px solid #ccc",
      borderRight:"1px solid #ccc",
     
    };
    const rowrightstyle = { 
      fontFamily: "Arial",  
      height:"30%",  
    }; 
    const colrightstyle = { 
      fontFamily: "Arial",  
      height:"100%",   
      borderTop:"1px solid #ccc",  
    }; 
    const colbuttonstyle = { 
      fontFamily: "Arial", 
      borderTop:"1px solid #ccc", 
      padding:"5px",
    }; 
    const btnLuustyle = { 
      fontFamily: "Arial",  
      marginLeft:"11px", 
    };
    const btnHoanTatstyle = { 
      fontFamily: "Arial",  
      marginLeft:"5px", 
    };
    const labelchandoan = { 
      fontFamily: "Arial", 
      fontWeight:"bold", 
    };
    const editbox = { 
      fontFamily: "Arial", 
      height:"80%", 
    };

    const ttbn = { 
      fontFamily: "Arial",
      fontSize:"13px",
      height:isMobile?"100px":"auto", 
    };
    const btnOpen = { 
      backgroundColor: "DodgerBlue",
      border: "none",
      color: "white",
      padding: "5px 30px",
      cursor: "pointer",
      fontSize: "15px", 
    };
    const divPDFMobile={
      paddingTop:"30%",
      
    }
    let ketqua1,ketqua2,ketqua3, type,mabenhnhan,hoten,tuoi,gioi,tenloaikham,nguoihoantat,ketquals1,ketquals2; 
    let data_files =[];
    let data_code =[];
    if (this.props.response.chitietcls.hasOwnProperty('response')) {
      if(typeof this.props.response.chitietcls.response=="undefined"){
        ketqua1="";
        ketqua2="";
        ketqua3="";
        mabenhnhan="";
        hoten="";
        tuoi="";
        gioi="";
        tenloaikham="";
        nguoihoantat="";
        this.isdisabled=0;
        ketquals1="";
        ketquals2="";
      }else{  
        let data_rs=this.props.response.chitietcls.response.data.chandoan[0];
        data_files=this.props.response.chitietcls.response.data.files;
        data_code=this.props.response.chitietcls.response.data.code;
        //console.log(isdisabled);
        this.isdisabled=parseInt(data_rs.isdisabled);  
        ketqua1=data_rs.ketqua1;
        ketqua2=data_rs.ketqua2;
        ketqua3=data_rs.ketqua3;
        mabenhnhan=data_rs.MaBenhNhan;
        hoten=data_rs.hotenbenhnhan;
        tuoi=data_rs.tuoi;
        nguoihoantat=(data_rs.tennguoihoantat===null?"":"(Bs đọc KQ: "+data_rs.tennguoihoantat+")");
        gioi=data_rs.gioitinh;
        tenloaikham=data_rs.tenloaikham;
        ketquals1=data_rs.ketquals1;
        ketquals2=data_rs.ketquals2;
         
        this.luu_ketqua1=this.luu_ketqua1===""?data_rs.ketqua1:this.luu_ketqua1;
        this.luu_ketqua2=this.luu_ketqua2===""?data_rs.ketqua2:this.luu_ketqua2;
        this.luu_ketqua3=this.luu_ketqua3===""?data_rs.ketqua3:this.luu_ketqua3;
         if(typeof data_files[0]=="undefined"){
          type="";
         }else{
          type=data_files[0].type;
         }
      } 
    }

    if(this.issave===1){
      this.issave=0;
      let isSuccess, message; 
      if (this.props.response.savedatacls.hasOwnProperty('response')) {
        if(typeof this.props.response.savedatacls.response!=="undefined"){
          isSuccess = this.props.response.savedatacls.response.success;
          message = this.props.response.savedatacls.response.message;
          if(isSuccess===true){
            toast.success(message, { position: toast.POSITION.TOP_RIGHT });
            this.isdisabled=this.props.response.savedatacls.response.disabled; 
          }else{
            toast.error(message, { position: toast.POSITION.TOP_RIGHT }); 
            this.isdisabled=this.props.response.savedatacls.response.disabled;
          }
        }else{
          toast.error("Lỗi kết nối", { position: toast.POSITION.TOP_RIGHT }); 
        }
      }else{
        toast.error("Lỗi kết nối", { position: toast.POSITION.TOP_RIGHT }); 
      }
      
    }
  this.pdf_view= <Pdfview files = {data_files} />
  let duongdan="";
  if(typeof(data_files[0])!=="undefined"){
    duongdan=data_files[0].duongdan;
  }
  if (isMobile) {
    this.pdf_view= <div className="container">
    <div className="row">
      <div className="col text-center" style={divPDFMobile}>
      <div>File PDF</div>
      <button className="btn btn-sm" onClick={()=>this.handleOpenLink(config.URL_WEBSERVICE+"/api/files/"+duongdan)} style={btnOpen}>OPEN</button>
      </div>
    </div>
  </div> 
  }
  let button;
  if(this.isdisabled===0 || this.state.isedit===true){
    button=<div>
      <button type="button" className="btn btn-primary btn-sm" onClick={this.handleSave} style={btnLuustyle}>Lưu</button>
      <button type="button" className="btn btn-success btn-sm" disabled={this.isdisabled} onClick={this.handleSaveAndDone} style={btnHoanTatstyle}>Hoàn tất</button>
      <button type="button" className="btn btn-light btn-sm" onClick={this.handleHome} style={btnHoanTatstyle}>Quay lại</button>
    </div>
  }else{
    button=<div>
      <button type="button" className="btn btn-primary btn-sm"  onClick={this.handleEdit} style={btnLuustyle}>Sửa</button>
      <button type="button" className="btn btn-primary btn-sm" disabled={this.isdisabled} onClick={this.handleSave} style={btnLuustyle}>Lưu</button>
      <button type="button" className="btn btn-success btn-sm" disabled={this.isdisabled} onClick={this.handleSaveAndDone}  style={btnHoanTatstyle}>Hoàn tất</button>
      <button type="button" className="btn btn-light btn-sm" onClick={this.handleHome}   style={btnHoanTatstyle}>Quay lại</button>
    </div>
  }

  let viewboxchandoan;
  let styletable={
    padding:'0.25rem'
  }


  let viewchandoanlamsang= []; 
    viewchandoanlamsang.push(<div className="row "  style={{height:"20vh"}}>
          <div className="col-md-12 " style={colrightstyle}>
            <div className="form-group h-100 d-flex flex-column">
              <label htmlFor="ketquals1" style={labelchandoan}>Diễn biến lâm sàng</label>
              <textarea  className="form-control " id="ketquals1" name="ketquals1" disabled={true} style={editbox} defaultValue={ketquals1} />
            </div>
          </div> 
      </div>) 

  // if(ketquals2!==""){
  //   viewchandoanlamsang.push(<div className="row " style={rowrightstyle}>
  //         <div className="col-md-12" style={colrightstyle}>
  //           <div className="form-group h-100 d-flex flex-column">
  //             <label htmlFor="ketquals2" style={labelchandoan}>Chẩn đoán</label>
  //             <textarea  className="form-control" id="ketquals2" name="ketquals2" disabled={true} style={editbox} defaultValue={ketquals2} />
  //           </div>
  //         </div> 
  //     </div> )
  // }

  if(data_code.length>0){
    let dscode = [];
    for(let i=0;i<data_code.length;i++){
      dscode.push(
        <tr>
          <td style={styletable}>Code {i}</td>
          <td style={styletable}>{data_code[i].tenmauchandoan}</td>
          <td style={{color:data_code[i].color,padding:'0.25rem'}}>{data_code[i].noiduntiengviet}</td>
          <td style={{color:data_code[i].color,padding:'0.25rem'}}>{data_code[i].noidungtienganh}</td> 
        </tr>
      )
     }
      viewboxchandoan=<div><div className="row " style={rowrightstyle}>
      <div className="col-md-12 " style={colrightstyle}>
        <table className="table table-bordered table-responsive" style={{maxHeight:"50vh",fontSize:"13px",marginTop:'3px'}}>
                <thead>
                  <tr>
                    <th scope="col" style={{width:"15%",padding:'0.25rem'}}>Code</th>
                    <th scope="col" style={{width:"15%",padding:'0.25rem'}}>Mẫu CĐ</th>
                    <th scope="col" style={{width:"35%",padding:'0.25rem'}}>Tiếng việt</th>
                    <th scope="col" style={{width:"35%",padding:'0.25rem'}}>Tiếng anh</th> 
                  </tr>
                </thead>
                <tbody>{dscode}</tbody>
              </table>
      </div> 
    </div> 
    <div className="row " style={{height:"20vh"}}>
      <div className="col-md-12 " style={colrightstyle}>
      <div className="form-group h-100 d-flex flex-column">
        <label htmlFor="chandoan2" style={labelchandoan}>Kết luận</label>
        <textarea className="form-control " id="chandoan2" name="chandoan2" disabled={(this.isdisabled && this.state.isedit===false)?true:false} onChange={this.chandoan2Change} style={editbox} defaultValue={ketqua2} />
      </div>  
      </div> 
    </div></div>
  }else{
      viewboxchandoan=<div style={{height:"57vh"}}>
        <div className="row " style={rowrightstyle}>
          <div className="col-md-12 " style={colrightstyle}>
            <div className="form-group h-100 d-flex flex-column">
              <label htmlFor="chandoan1" style={labelchandoan}>Mô tả</label>
              <textarea  className="form-control " id="chandoan1" name="chandoan1" disabled={(this.isdisabled && this.state.isedit===false)?true:false} onChange={this.chandoan1Change} style={editbox} defaultValue={ketqua1} />
            </div>
          </div> 
      </div> 
    <div className="row " style={rowrightstyle}>
      <div className="col-md-12 " style={colrightstyle}>
      <div className="form-group h-100 d-flex flex-column">
        <label htmlFor="chandoan2" style={labelchandoan}>Kết luận</label>
        <textarea className="form-control " id="chandoan2" name="chandoan2" disabled={(this.isdisabled && this.state.isedit===false)?true:false} onChange={this.chandoan2Change} style={editbox} defaultValue={ketqua2} />
      </div>  
      </div> 
    </div>
    <div className="row " style={rowrightstyle}>
      <div className="col-md-12 " style={colrightstyle}>
        <div className="form-group h-100 d-flex flex-column">
          <label htmlFor="chandoan3" style={labelchandoan}>Đề nghị/Lời khuyên</label>
          <textarea className="form-control " id="chandoan3" name="chandoan3" disabled={(this.isdisabled && this.state.isedit===false)?true:false} onChange={this.chandoan3Change} style={editbox} defaultValue={ketqua3} />
        </div>  
      </div> 
    </div></div>
  }

    return (
      <div className="h-100 d-flex flex-column">
         <HeaderPage />
        <div className="container-fluid h-100 d-flex flex-column" style={col_parent}> 
            <div className="row mb-1" >
              <div className="col-md-12 mb-2 mt-2" style={ttbn}> 
                  <p className="card-text mb-0">BN: <strong>{hoten}</strong>, ID: {mabenhnhan}, Giới tính: {gioi}, Tuổi: {tuoi} </p>
                <p className="card-text mb-0">{tenloaikham} {nguoihoantat}</p>
              </div>
            </div>
            <div className={isMobile?"row class-row-cls":"row h-100  class-row-cls"} >
              <div className={type==='pdf'?'col-md-8 class-colleft-cls pdf-view h-100': 'col-md-7 class-colleft-cls img-view h-120'} style={colleftstyle} >
              {type==="pdf"? this.pdf_view: <Imageview  files = {data_files}/>}
              </div>
              <div className={type==='pdf'?'col-md-4 h-100': 'col-md-5 h-100 img-view'}>
                {viewchandoanlamsang}
                {viewboxchandoan}
                <div className="row ">
                  <div className="col-md-12" style={colbuttonstyle}>
                    {button}
                  </div>
                </div>
              </div> 
        </div>
      </div>
      <ToastContainer />
      </div>
    );
  }
}
 
const mapStateToProps = (response) => ({response});
export default connect(mapStateToProps)(Cls); 